"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PARTNER_SUPPORT_VIDEO_HOURS_PT = exports.PARTNER_SUPPORT_HOURS_PT = exports.PARTNER_VIDEO_BREAK_PT = void 0;
const MONDAY_THROUGH_FRIDAY_PT = [1, 2, 3, 4, 5];
const MONDAY_THROUGH_THURSDAY_PT = [1, 2, 3, 4];
const FRIDAY_PT = [5];
/** Video support pauses 1:00–1:30pm PT, splitting each video day into two windows. */
exports.PARTNER_VIDEO_BREAK_PT = { start: 13, end: 13.5 };
/** Shared by the partner dashboard support button and the partner support pager. */
exports.PARTNER_SUPPORT_HOURS_PT = {
    callMe: { start: 7, end: 17, days: MONDAY_THROUGH_FRIDAY_PT },
    video: {
        morning: { start: 7, end: exports.PARTNER_VIDEO_BREAK_PT.start, days: MONDAY_THROUGH_FRIDAY_PT },
        mondayThroughThursdayAfternoon: { start: exports.PARTNER_VIDEO_BREAK_PT.end, end: 19, days: MONDAY_THROUGH_THURSDAY_PT },
        fridayAfternoon: { start: exports.PARTNER_VIDEO_BREAK_PT.end, end: 17, days: FRIDAY_PT },
    },
    chat: { start: 7, end: 17, days: MONDAY_THROUGH_FRIDAY_PT },
};
/** The three video windows, derived once for all consumers. */
exports.PARTNER_SUPPORT_VIDEO_HOURS_PT = Object.values(exports.PARTNER_SUPPORT_HOURS_PT.video);
